// extracted by mini-css-extract-plugin
export default {"vendorType":"vendorType__OGNjY","withRating":"withRating__OWVmN","ratingStars":"ratingStars__Mzg5Y","typeLocation":"typeLocation__Y2I2O","dot":"dot__MjQyN"};